import { defaultStringifySearch } from '@tanstack/react-router';

/// Atividade, situação e tipo de mensagem já aceitam escolhas múltiplas. Os demais
/// parâmetros preservam o formato anterior até a migração da respectiva tela. A leitura padrão
/// do roteador aceita tanto chaves repetidas quanto listas JSON dos links antigos.
export function stringifyListSearch(search: Record<string, unknown>): string {
  const params = new URLSearchParams(defaultStringifySearch(search));
  for (const key of ['activity', 'status', 'event', 'access']) {
    const value: unknown = search[key];
    if (Array.isArray(value)) {
      params.delete(key);
      for (const choice of value) params.append(key, String(choice));
    }
  }
  const query = params.toString();
  return query ? `?${query}` : '';
}
